import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Tabs, Tab } from '@mui/material';

import exporting from 'highcharts/modules/exporting';
import Highcharts from 'highcharts';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more';

import { changeChartTab, toggleChartVisible } from '../../store/ui/ui.slice';
import {
  selectChartTab,
  selectIsChartVisible,
} from '../../store/ui/ui.selector';
import {
  selectIsClimate,
  selectUseHurricaneApi,
} from '../../store/options/options.selector';

import { defaultOptions } from './charts/chart-default-configurations';

import Section from '../section/section.component';
import ProjectedChart from './charts/projected-chart.component';
import HistoricalChart from './charts/historical-chart.component';
import HazardChart from './charts/hazard-chart.component';
import HurricaneChart from './charts/hurricane-chart.component';
import CloseBtn from '../close-btn/close-btn.component';

import './chart-container.styles.scss';

highchartsMore(Highcharts);
exporting(Highcharts);
NoDataToDisplay(Highcharts);

Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
    numericSymbols: ['k', 'M', 'B', 'T', 'Qd', 'Qt'],
  },
});

export default function ChartContainer() {
  const dispatch = useDispatch();
  const tab = useSelector(selectChartTab);
  const isClimate = useSelector(selectIsClimate);
  const isChartVisible = useSelector(selectIsChartVisible);
  const useHurricaneApi = useSelector(selectUseHurricaneApi);

  const handleTabChange = (e, newTab) => {
    dispatch(changeChartTab(newTab));
  };

  const handleCloseChart = () => {
    dispatch(toggleChartVisible());
  };

  const renderChart = () => {
    let Component;
    if (!isClimate) {
      Component = useHurricaneApi ? HurricaneChart : HazardChart;
    } else if (tab === 'historical') {
      Component = HistoricalChart;
    } else if (tab === 'veryHigh' || tab === 'high' || tab === 'intermediate') {
      Component = ProjectedChart;
    } else {
      return Component;
    }

    return (
      <Component
        HighchartsReact={HighchartsReact}
        Highcharts={Highcharts}
        defaultOptions={defaultOptions}
      />
    );
  };

  return (
    <Section
      className='chart-container-component fadeable'
      sx={{
        pointerEvents: isChartVisible ? 'all' : 'none',
        opacity: isChartVisible ? 1 : 0,
      }}
    >
      {isClimate && (
        <div className='chart-tabs-container'>
          <Tabs
            className='chart-tabs'
            value={tab}
            onChange={handleTabChange}
            variant='fullWidth'
          >
            <Tab
              className={`${
                tab === 'historical' ? 'tab-selected' : 'tab-unselected'
              }`}
              style={{ height: '100%' }}
              value='historical'
              label='Historical Data'
            />
            <Tab
              className={`${tab === 'veryHigh' ? 'tab-selected' : 'tab-unselected'} bottom-tab`}
              value='veryHigh'
              label='Very High'
              id='center-tab'
            />
            <Tab
              className={`${tab === 'high' ? 'tab-selected' : 'tab-unselected'} bottom-tab`}
              value='high'
              label='High'
              id='center-tab'
            />
            <Tab
              className={`${tab === 'intermediate' ? 'tab-selected' : 'tab-unselected'} bottom-tab`}
              value='intermediate'
              label='Intermediate'
            />
          </Tabs>
          <div className='tab-label'>
            <h4>Emissions Futures</h4>
          </div>
        </div>
      )}

      <CloseBtn handleClose={handleCloseChart} />

      <div className='chart-container' style={{ height: '100%' }}>
        {renderChart()}
      </div>
    </Section>
  );
}
